import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

export const Hero = () => {
  return (
    <Container fluid className="hero" as="section">
      <Container>
        <Row>
          <Col sm="12" md="12" lg="6">
            <p className="welcome-text">Welcome</p>
            <h1>London Based Drummer</h1>
            <p>
              Offering services from sessions work to drum lessons as well as
              providing drum tracks for albums.
            </p>
            <a href="/contact"><Button className="contact-btn">Contact Me</Button></a>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
